import * as z from "zod/v4";

export const addAeoPrompts = {
  name: "addAeoPrompts" as const,
  input: z.object({
    prompts: z.array(z.string().min(1).max(1000)).max(100),
    category: z.string().default("General"),
  }),
  output: z.object({ success: z.boolean(), addedCount: z.number() }),
};
